/* unplugin-vue-components disabled */import { render } from "./edit-modal.vue?vue&type=template&id=4b54a50a&scoped=true"
import script from "./edit-modal.vue?vue&type=script&lang=js"
export * from "./edit-modal.vue?vue&type=script&lang=js"

import "./edit-modal.vue?vue&type=style&index=0&id=4b54a50a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b54a50a"],['__file',"src/pages/tenants/user/topics/edit-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b54a50a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b54a50a', __exports__)) {
    api.reload('4b54a50a', __exports__)
  }
  
  module.hot.accept("./edit-modal.vue?vue&type=template&id=4b54a50a&scoped=true", () => {
    api.rerender('4b54a50a', render)
  })

}


export default __exports__